export const WORK_TYPE_LABELS = {
    1: 'Movie',
    2: 'Series',
    3: 'Season',
    4: 'Episode',
};
export const TOOL_LOG_LEVEL_COLORS = {
    info: 'var(--color-info)',
    warning: 'var(--color-warning)',
    error: 'var(--color-danger)',
};
export const LOG_LEVEL_COLORS = {
    Verbose: 'var(--color-text-muted)',
    Debug: 'var(--color-text-muted)',
    Information: 'var(--color-info)',
    Warning: 'var(--color-warning)',
    Error: 'var(--color-danger)',
    Fatal: 'var(--color-danger)',
};
export function formatDate(iso) {
    return new Date(iso).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
}
export function formatDateTime(iso) {
    return new Date(iso).toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
}
export function pct(n, total) {
    if (total === 0)
        return '0%';
    return `${((n / total) * 100).toFixed(1)}%`;
}
